export function sanitizeJsonString(jsonString: string): string {
    return jsonString
        .replace(/[\x00-\x1F\x7F]/g, (match) => {   // Escape control characters (tabline, new line)
            return '\\u' + ('000' + match.charCodeAt(0).toString(16)).slice(-4);
        })
}
